import * as React from 'react'

import { Index } from '../components/routes/public'
import RoutePublic from '../components/routes/RoutePublic'

const IndexPage = () => {
  return (
    <RoutePublic
      title="Codemochi Courses"
      description="Learn something new today."
      path="/"
      component={Index}
    />
  )
}

export default IndexPage
